import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=17852ff6&scoped=true"
import script from "./SkeletonLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonLoader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=17852ff6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17852ff6",
  null
  
)

export default component.exports